// src/gateway/auth-gateway.ts
import Alpine from 'alpinejs';
import config from '@src/js/config';
import { OrganisationService } from "@src/js/services/organisationService";
import { User } from "@src/js/types/user";
import { Organisation } from "@src/js/types/organisation";
export async function runAuthGateway() {
    Alpine.store('authReady', false);
    function getUser() {
        return Alpine.store('user') || null;
    }
    const allowedPaths = ['/auth', '/confirm-signup', '/assistants/shared.html'];
    const currentPath = window.location.pathname;
    const isAllowedPath = allowedPaths.some(prefix => currentPath.startsWith(prefix));
    console.log('Path:', currentPath);
    console.log('Is allowed path:', isAllowedPath);
    // ✅ Early exit on allowed paths
    if (isAllowedPath) {
        console.log('Allowed path detected, skipping auth check');
        Alpine.store('authReady', true);
        return;
    }
    try {
        const token = document.cookie
            .split('; ')
            .find(row => row.startsWith('token='))?.split('=')[1];
        const user = getUser();
        console.log('User:', user);
        console.log('Token present:', !!token);
        // Session wiederherstellen, wenn Token vorhanden aber kein User geladen
        if (token && !user) {
            const url = `${config.API_URL}account/login`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (response.ok) {
                const userData = await response.json();
                const user = new User(userData);
                Alpine.store('user', user);
                console.log('Authenticated user:', user);
            }
            else {
                console.warn('Token check failed:', response.status);
            }
        }
        const updatedUser = getUser();
        if (!updatedUser) {
            console.log('User not logged in, redirecting to login page');
            window.location.href = config.APP_URL + 'auth.html?state=login';
        }
        else {
            console.log('User is logged in, loading orgnisation data');
            const organisationData = await OrganisationService.getById(updatedUser.organisationId);
            const organisation = new Organisation(organisationData);
            // add a method to check whether the organisation has a certain feature flag
            Alpine.store('organisation', organisation);
            setTimeout(() => {
                Alpine.store('authReady', true);
            }, 10);
        }
    }
    catch (error) {
        console.error('Auth check error:', error);
        // window.location.href = config.APP_URL + 'auth.html?state=login';
    }
}
